import { Component, EventEmitter, Output } from '@angular/core';
import { ShapeService } from '../../element-editor/shape/shape.service';
import {
  setFile,
  setResourcePost,
} from '../../element-editor/store/editor.actions';

export interface UploadedImage {
  file: File;
  preview: string;
  name: string;
  size: number;

  id: string;
}

@Component({
  selector: 'nw-image-upload-modal',
  templateUrl: './image-upload-modal.component.html',
  styleUrls: ['./image-upload-modal.component.scss'],
})
export class ImageUploadModalComponent {
  @Output() cancel = new EventEmitter<void>();
  @Output() upload = new EventEmitter<UploadedImage[]>();

  isDragging = false;
  uploadedImages: UploadedImage[] = [];

  get cs() {
    return this.service.cs;
  }

  get store() {
    return this.service.store;
  }

  constructor(private service: ShapeService) {}

  onClose() {
    this.cancel.emit();
  }

  onUpload() {
    if (this.uploadedImages.length > 0) {
      this.upload.emit(this.uploadedImages);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files) {
      this.handleFiles(files);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.handleFiles(input.files);
    }
  }

  handleFiles(files: FileList) {
    console.log('handleFiles', files); // -- //
    Array.from(files).forEach(file => {
      // Only accept image files
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
          const id = this.service.getNewID();
          this.uploadedImages.push({
            file,
            preview: e.target?.result as string,
            name: file.name,
            size: file.size,
            id,
          });
          this.uploadFile(id, file);
          /* this.cs.httpService.saveFileToS3(file, id).then(() => {
            console.log('yooo -> image uploaded');
          }); */
        };
        reader.readAsDataURL(file);
      }
    });
  }

  uploadFile(id: string, file: File) {
    this.cs.httpService.saveFileToS3(file, id).then(() => {
      console.log('yooo -> image uploaded');
    });
    const resourceData = {
      type: 'nw:File',
      IRI: this.service.getNewIRI(),
      literals: {
        label: file.name,
        descriptor: {
          type: 'image',
          s3Id: id,
        },
      },
      relationships: {
        project: this.cs.currentProject.IRI,
      },
    };

    this.store.dispatch(setFile({ file: resourceData }));
    this.store.dispatch(
      setResourcePost({ IRI: resourceData.IRI, resourceType: 'nw:File' }),
    );
  }

  removeImage(index: number) {
    this.uploadedImages.splice(index, 1);
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }

  triggerFileInput() {
    const fileInput = document.getElementById('file-input') as HTMLInputElement;
    fileInput?.click();
  }
}
